import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

console.log('🚀 Starting Future Station app...');
console.log('🔧 Environment check:', {
  isDev: import.meta.env.DEV,
  mode: import.meta.env.MODE,
  command: import.meta.env.COMMAND
});

console.log('📦 Testing imports...');
console.log('App import:', typeof App);
console.log('HelmetProvider import:', typeof HelmetProvider);
console.log('createRoot import:', typeof createRoot);

try {
  console.log('🔍 Checking DOM...');
  console.log('Document ready state:', document.readyState);
  console.log('Document body:', !!document.body);
  
  const rootElement = document.getElementById("root");
  console.log('📍 Root element found:', !!rootElement);
  console.log('Root element details:', rootElement ? {
    tagName: rootElement.tagName,
    id: rootElement.id,
    innerHTML: rootElement.innerHTML.slice(0, 100)
  } : 'null');
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  console.log('🔧 Creating React root...');
  const root = createRoot(rootElement);
  console.log('Root created successfully:', !!root);
  
  console.log('🎨 Rendering app...');
  root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
  
  console.log('✅ App rendered successfully');
  
  // Check if the app actually rendered
  setTimeout(() => {
    console.log('📊 Post-render check:', {
      rootHasContent: rootElement.children.length > 0,
      firstChildTag: rootElement.children[0]?.tagName
    });
  }, 100);
  
} catch (error) {
  console.error('❌ Failed to initialize app:', error);
  console.error('Error stack:', error.stack);
  
  // Try to show error in the DOM
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="color: red; padding: 20px; font-family: monospace;">
        <h1>Erro ao carregar a aplicação</h1>
        <p>Detalhes: ${error.message}</p>
        <pre>${error.stack}</pre>
      </div>
    `;
  }
}
